var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFalconreport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 387.6 427.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-6, .cls-9, .cls-11 {\n        stroke: #121214;\n      }\n\n      .cls-1, .cls-12 {\n        fill: none;\n      }\n\n      .cls-2, .cls-13 {\n        fill: #aeadae;\n        stroke: #aeadae;\n      }\n\n      .cls-3, .cls-5, .cls-12 {\n        stroke: #101013;\n      }\n\n      .cls-3, .cls-9 {\n        fill: #121214;\n      }\n\n      .cls-4, .cls-14, .cls-15, .cls-16, .cls-13 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4, .cls-6, .cls-15 {\n        fill: #6d7a9c;\n      }\n\n      .cls-4, .cls-15 {\n        stroke: #6d7a9c;\n      }\n\n      .cls-5, .cls-17, .cls-10, .cls-11 {\n        fill: #e9e9e9;\n      }\n\n      .cls-14, .cls-8 {\n        fill: #292d3f;\n        stroke: #292d3f;\n      }\n\n      .cls-17 {\n        stroke-width: 0px;\n      }\n\n      .cls-7 {\n        fill: #4c4b4c;\n        stroke: #4c4b4c;\n      }\n\n      .cls-16 {\n        fill: #2d2d2d;\n        stroke: #2d2d2c;\n      }\n\n      .cls-10 {\n        stroke: #e9e9e9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 196.4,
    y1: 257.6,
    x2: 196.9,
    y2: 258.2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arms_Colours",
    "data-name": "Arms Colours"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M311,272.28l-20.75,77.65-1.38,50.4h-69.89l2.29-74.49,36.31-71.04s17.19,6.24,27.55,3.46c0,0,11.59,12.59,15.28,13.39s12.34.62,12.34.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "320.35 262.25 314.91 272.98 300.76 268.91 287.62 255.08 262.82 252.29 269.05 242.15 291.58 244.76 305.85 258.21 320.35 262.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M82.83,272.28l20.75,77.65,1.38,50.4h69.89l-2.29-74.49-36.31-71.04s-17.19,6.24-27.55,3.46c0,0-11.59,12.59-15.28,13.39s-12.34.62-12.34.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M78.56,267.4l4.75,6.71s35.66,41.71,22.17,70.74-11.07.22-11.07.22c0,0-19.15-18.7-19-23.46s-26.3,5.13-24.83.61c3.34-10.26,8.42-25.39,8.42-25.39,11.3-2.67,17.36-17.44,19.57-29.42h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "77.21 257.37 82.3 269.03 95.56 267.36 107.87 255.75 131.11 257.17 126.24 241.48 104.16 244.76 90.79 255.79 77.21 257.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M302.36,362.22s14.55-22.01,14.18-29.7-21.37,12.54-21.37,12.54c0,0,13.52-25.68,15.68-33.25s-4.6-20.01-4.6-20.01c-16.49-2.43-30.55-24.33-39.2-25.95s-13.52,3.3-13.52,3.3l7.62-15.61,23.32,3.53,14.84,15.02s13.02,4.68,17.71.89l6.32,35.27s-4.49,3.93-1.32,6.37,1.37,9.69,1.37,9.69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arms_Lines",
    "data-name": "Arms Lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M315.51,264.87c-.04-3.45-5-4.95-7.45-5.16s-5.75,1.41-5.75,4.61,3.3,3.8,6.6,4.09c3.3.29,6.64-.38,6.6-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M267.27,240.4s21.47.65,25.94,3.87,10.48,11.19,13.09,13.23,15.11,1.37,15.72,4.35c0,0-5.04,12.04-6.53,11.91s-14.43-1.82-16.9-3.99-7.86-11.08-12.64-13.29-24.81-2.93-24.81-2.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M312.36,273.89s-6.21,25.49-7.23,30.62-13.31,40.55-13.53,49.07-1.35,52.55-1.35,52.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M293.8,347.77c17.05-13.55,24.09-31.3,24.09-31.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81.74,260.82c.04-3.44,4.69-4.1,6.98-3.9s5.39,2.39,5.39,5.58-3.09,3.24-6.19,2.97-6.22-1.5-6.19-4.65h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M126.24,241.48s-19.42.06-23.61,2.52-9.82,9.42-12.27,11.01-14.16-1.19-14.73,1.68c0,0,4.72,12.9,6.11,13.02s13.52.63,15.83-1.13,7.36-9.75,11.84-11.15,23.25,1.28,23.25,1.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M46.73,323.99c-.94-5.15,6.52-9.14,12.26-27.17,8.45-2.63,20.48-26.36,19.12-33.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M102.23,353.57c.22,8.52,0,49.15,0,49.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M95.22,269.15s8.95-2.26,14.06,11.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Main_Colours",
    "data-name": "Main Colours"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "196.91 326.87 210.64 330.95 235.96 247.05 265.78 151.29 248.37 140.1 174.57 147.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M188.44,61.23s11.09-1.57,19.79-4.44,16.29.99,17.28,4.44,12.21,43.78,12.21,43.78c0,0-31.25,12.84-49.85,12.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M195.46,401.96s18.8,9.72,21.6-10.37-1.6-84.27-1.6-84.27l-18.55,21.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M186.84,156.8s4.01,1.48,39.88,0c35.88-1.48,64.32-17.43,64.72-27.41s-53.72-24.38-53.72-24.38l-50.32-5.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M305.85,155.27l-38.62,66.84s.72,6.21-2.68,20.16c-3.4,13.94-11.02,20.71-11.02,20.71l-34.98,75.1c-.89-37.55-.96-79.33-6.46-93.39l18.54-6.28-15.54-53s80.49-9.87,90.76-30.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M270.53,147.85s6.5-2.95,13.99-2.69c9.7.34,20.93,4.29,20.52,8.54-.73,7.53-57.9,24.02-57.9,24.02,0,0,5.16-6.65,3.5-17.2s-14.63-4.28-14.63-4.28l34.52-8.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.81,207.83s5.02,19.37,4.7,28.73l-4.02,2.18-.68-30.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M246.24,164.84s1.05,9.4-6.35,12.53c0,0,2.64-1.95,2.78-4.26s-1.8-6.23-.69-7.84,1.56-4.3,1.56-4.3l2.69,3.86h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M184.03,181.8s7.24-1.87,8.21-.97,1.08,3.01.81,3.9c-.2.64-6.98,4.2-9.73,4.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "196.91 326.87 183.18 330.95 157.87 247.05 128.04 151.29 146.57 155.88 180.53 155.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M188.44,61.23s-11.09-1.57-19.79-4.44-16.29.99-17.28,4.44-12.21,43.78-12.21,43.78c0,0,31.25,12.84,49.85,12.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M198.36,401.96s-18.8,9.72-21.6-10.37,1.6-84.27,1.6-84.27l18.55,21.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M187.97,156.8s-2.06-.45-37.94-1.93-66.27-15.5-66.67-25.48,52.3-24.04,52.3-24.04l51.74-5.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M96.22,169.55l29.52,51.09s.12,7.68,3.52,21.62c3.4,13.94,10.39,19.51,10.39,19.51l35.61,76.3,4.4-93.94-20.22-5.38,15.12-59.37c.49-2.06-65.69.4-78.34-9.82h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.6,152.38s-22.82,1.85-22.08,9.38c.73,7.53,34.43,11.76,34.43,11.76,0,0-4.24-3.98-3.98-14.66.12-4.78.57-4.85.57-4.85l-8.95-1.62h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.01,207.83s-8.13,19.15-7.81,28.51l7.13,2.4.68-30.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M242.44,122.98l-4.39-13.05s-7.46,3.42-18.18,6.99c-9.7,3.23-28.42,4.81-31.9,5.09-3.48-.27-22.2-1.85-31.9-5.09-10.72-3.57-18.18-6.99-18.18-6.99l-4.39,13.05s29.24,16.91,54.47,15.7c25.23,1.2,54.47-15.7,54.47-15.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M129.87,161.04s-.65,11.21,6.75,14.34c0,0-3.04-3.76-3.18-6.06s1.8-6.23.69-7.84-1.56-4.3-1.56-4.3l-2.69,3.86h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M184.03,181.8s-7.24-1.87-8.21-.97-1.08,3.01-.81,3.9c.2.64,6.28,1.38,9.02,1.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.19,170.91s-6.78,16.67-7.2,30.69-14.46,21.37-14.46,21.37c0,0-7.59.39-12.15-6.57-1.27-13.69-3.54-28.04,1.16-33.54l-5.45,3.42-6.02,17.11v33.96l10.24,4.92-5.54,62.24,16.27,11.97,9.36-49.58-1.39-3.52-1.81-5.83-9.14-1.31,1.59-22.21s8.17,8.25,12.59,6.28,6.76-5.04,6.76-5.04l2.56,5.92,8.84-3.34-2.22-30.62,1.36-1.5-6.44-20.33,16.48-4.07,1.41-9.84-16.8-.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.73,163.36s2.6,8.39-.72,12.01-7.01.3-7.01.3l7.73-12.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M141.56,172.38s31.51-18,70.65,9.5c7.97,5.6,17.77-1.29,17.77-1.29l6.04-24.34s-46.07,3.17-57.2,2.86c-11.14-.31-39.16-3.84-39.16-3.84l1.9,17.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M169.43,55.53s-.15,11.08,9.4,10.59,24.12-7.06,24.12-7.06c0,0-1.32,9.28-.84,11.07s7.46,13.3,6.97,20.11,3.57,25.94,3.57,25.94l24.81-11.35s-10.05-44.75-14.27-46.54-9.4-3.57-9.4-3.57c0,0-18.03,6.26-26.94,6.26s-17.41-5.45-17.41-5.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M219.99,134.8s54.96-3.28,63.55,6.4c0,0,12.85-11.53,8.79-14.65s-15.63-11.92-31.4-15.36c-15.77-3.44-23.21-6.18-23.21-6.18l5.38,19.32s-16.24,10.77-23.11,10.46h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "212.25 118.21 217.19 135.06 241.99 122.86 237.83 108.9 212.25 118.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M195.07,327.57s-6.72,59.87-4.85,75.36-11.86,1.41-11.86,1.41c0,0-5.6-73.2-1.6-99.84l18.31,23.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M287.06,160.79s-10.54,27.25-14.06,34.52-19.46,22.41-19.46,32.41,5.68,10.03,6.22,15.97c.41,4.45-3.29,16.54-5.17,22.31,0,0,13.85-30.78,14.2-40.86s18.28-37.12,18.28-37.12l15.29-29.9-15.29,2.67h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M175.32,314.62l2.28-39.19s4.6-16.88,17.47-17.22l13.45,15.78,6.96-1.56,17.5,28.67,21.93,26.12s2.61-.76,8.14,2.5,6.44-6.58,6.44-6.58c0,0,6.89-.85,8.45-7.29s2.91-16.95,2.91-16.95c0,0,15.87-22.57,34.45-23.76,0,0,6.01-5.77,7.12-2.02s8.62,37.05,3.64,48.55-15.73,27.58-15.73,27.58c0,0,1.19,2.17-1.63,4.84s-25.97,37.34-32.77,36.31-34.68-8.61-38.6-12.68-24.52-16.2-29.7-20.36-4.15-14.23-4.15-14.23c0,0-25.37-26.33-28.17-28.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M187.77,199.64v6.03l-3.24,3.04s5.55.46,7.91-.42,5.65-4.62,4.31-5.96-8.98-2.69-8.98-2.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M104.13,369.96s51.77-54.86,58.35-54.92-5.68-47.05-1.41-53.27,20.66-18.99,20.66-18.99l-6.88,1.34-36.9,23.27-35.72,86.18,1.9,16.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M184.04,266.57s-4.73,32.42,1.15,44.14c5.88,11.72,13.88,25.05,18.89,26.16s37.31,2.33,37.31,2.33c0,0-31.84,1.3-31.3,10.04s3.59,12.97,3.59,12.97c0,0-10.71-2.36-11.31-15.47s0,0,0,0c0,0-16.03-22.48-27.06-32.13l2.28-39.19,6.44-8.85h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M222.89,285.54l34.35,38.77,6.91.89,3.07-4.63,6.91-5.09s-16.83,1.72-20.6-8.16-7.04-25.23-7.04-25.23c0,0-2.3,12.28-5.57,11.32s-13.69-11.32-13.69-11.32l-4.35,3.45h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M305.85,273.63s13.5,14.02,13.5,23.18-19.59,29.26-19.59,29.26c0,0,11.47-6.37,12.99,2.54,2.76,16.23-12.99,39.33-12.99,39.33l10.58-16.18,16.14-31.19c.61-20.74-2.57-37.09-6.13-53l-4.41,7.2-10.08-1.14h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Main_Lines",
    "data-name": "Main Lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M234.41,155.27s-.43,11.5-2.84,26.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M234.27,157.42s9.59-6.33,13.01-2.06,4.57,12.45,1.85,18.63c-.22.5-.5,1.07-.83,1.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M246.12,163.84s-.62-4.91-2.28-4.73-4.89,6.54-3.51,9.44,2.72,4.21,1.8,6.09c-.44.9-1.35,1.75-2.25,2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M189.61,183.12s-1.36-.49-2.83-.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M214.91,270.11c-1.48-17.55-4.82-27.33-4.82-27.33,4.92-2.46,18.76-4.92,18.76-4.92-1.02-22.54-13.77-52.47-13.77-52.47,0,0,91.22-17.39,91.22-30.93,0-5.74-11.81-9.87-22.32-12.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M217.06,400.33c.74-8.66,1.66-25.01,1.92-34.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M236.58,301.92c8.04-17.52,17.72-37.44,23.58-45.35,11.41-15.41,8.84-31.14,10.77-36.28s35.38-65.02,35.38-65.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M171.63,207.19s-.14,21.59-.4,31.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M212.09,249.54s-13.84,7.02-20.94,6.67c0,0,.53.31-1.25-2.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M203.41,265.15c-3.31-7.61-4.49-9.29-8.98-9.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M166.33,208.59c4.46,8.5,13.64,18.76,20.33,18.76s28.34-13.41,35.32-21.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M137.75,155.26c3.57,6.4,2.13,11.8,3.81,19.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M126.36,153.2c-2.01,4.67-2.12,11.63.41,16.87.41.84,1.48,2.36,2.17,3.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M130.7,160.54s.23-4.94,1.58-4.87,4.28,6.19,3.33,9.19-1.96,4.38-1.12,6.19c.53,1.13,1.69,2.13,2.64,3.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M177.7,183.12s1.36-.49,2.83-.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M135.61,103.35s-54.03,11.58-54.03,26.56c0,23.15,80.06,28.26,105.83,28.26s105.83-5.11,105.83-28.26c0-14.98-54.03-26.56-54.03-26.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M199.27,59.82c-10.75,0-29.32-5.1-35.84-4.91-4.7.13-13.61,3.5-15.26,8.66l-16.05,60.12s20.91,15.51,55.28,15.51,55.28-15.51,55.28-15.51l-16.05-60.12c-1.65-5.15-10.71-9.84-15.26-8.66-5.39,1.4-21.15,12.21-34.24,11.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M138.12,108.04s22.78,12.59,49.28,12.59,49.28-12.59,49.28-12.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M176.76,400.33c-7.93-127.91,6.45-161.59,6.45-161.59-4.92-2.46-20.74-.88-20.74-.88,1.02-22.54,14.38-60.54,14.38-60.54,0,0-83.85-.45-83.85-13.99,0-7.35,12.24-11.03,21.38-12.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M171.01,332.98s-25.94-61-37.35-76.42c-11.41-15.41-8.84-31.14-10.77-36.28s-29.39-55.45-29.39-55.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M220.47,207.83s1.87,20.95,2.13,30.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M178.82,197.19s19.08.35,19.93,5.08c1.95,10.81-19.93,8.86-19.93,8.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.4,192.59s-2.97,2.21-8.1,2.52-15.69,6.09-15.69,6.09l2.36-4.48c10.68-4.47,13.58-9.95,21.43-7.33,7.85-2.62,18.18,4.74,21.1,5.57s10.34-.09,10.34-.09c0,0-8.43,3.14-23.34.25-5.05-.98-8.1-2.52-8.1-2.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M186.67,230.63s-.04.08,3.39.89c0,0,3.58,13.65,3.37,16.31s-5.98,7.08-5.14,11.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M175.97,276.94c2.66-3.98,4.89-15.17,19.15-20.74l14.98,16.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M225.68,282.22s-6.72,1.36-11.44,6.07-9.74,15.48-9.74,15.48l-11.06,5.12-4.16-11.85s7.59-14.54,12.04-18.31,16.29-9.58,16.29-9.58c0,0,9.86,12.73,10.13,13.81s-1.07,7.44-1.07,7.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M195.59,301.33c4.74,3.08,12.14-5.07,6.4-8.98-5.02-3.42-11.09,5.93-6.4,8.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M311.12,273.75s-17.61,1.29-32.16,24.67c0,0-.51,15.91-5.7,20.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M174.99,316.51s27.39,26.77,27.39,30.24,1.57,11.57,6.15,13.11c9.72,3.25,28.85,19.32,36.04,21.82s24.8,13.23,31.37,10.42,35.79-35.16,36.11-40.23,15.84-21.54,15.84-32.94.85-29.91-7.64-52.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M299.76,302.01s-21.56,17.54-31.18,20.14l-2.92,5.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M221.4,284.08s8.96,11.3,14.64,19.03c4.03,5.49,20.44,22.09,20.44,22.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M210.91,320.57s35.69,5.67,45.56,4.63,17.31,14.6,14.97,27.32-6.88,21.82-6.88,21.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M282.16,365.51s3.31-22.08-1.36-27.28-12.21-5.25-12.21-5.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M69.91,188.52s-45.95,25.52-64.73-7.2c-15.75-27.44,22.44-55.33,49.41-51.88,19.54,2.5,46.28,20.71,26.48,50.7,0,0,0,8.76,13.77,11.13,0,0-9.58,9.93-24.94-2.75h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.84,147.76l10.6-2.75s-1.51,7.9,2.46,8.19c3.97.29,15.74-8.06,15.74-4.91s-4.93,28.01-12.46,25.23-18.89-16.35-18.89-16.35c0,0,27.51-.94,28.88,1.25s12.85,3.77,14.63-.47-17.24-7.81-19.43-2.69c-2.19,5.12,3.26,13.03,9.97,13.03s21.7-10.8,14.45-7.52-10.62,20.1-13.87,18.32c-18.07-9.94,6.02-3.56,6.02-3.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.86,177.57s-7.24,10.84-11.21,4,7.72-16.16,7.86-20.68-1.37-18.75-3.56-17.11-13,15.19-7.67,18.2,11.09,2.46,7.67-1.64-21.63,2.46-21.63,6.71,23.2,1.05,28.23.8,11.95-19.2,11.95-19.2c0,0,9.86-11.84,8.97-6.23-3.74,23.65,9.8,34.98,7.47,36.8s-20.76.42-24.59-1.23-27.51,2.05-25.87-.14,4.79-4.34,4.79-4.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M246.56,78.18l4.62-29.43,12.63,4.09-13.79,26.48c-.97,1.86-3.79.93-3.46-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M257.86,87.79l15.52-23.26,7.57,9.94-20.75,15.52c-1.47,1.1-3.35-.69-2.33-2.21h-.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 245.51,
    cy: 87.74,
    r: 3.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 252.97,
    cy: 95.71,
    r: 3.56
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M120.92,248.85l10.64-15.29-.93-28.05,13.56-16.09s11.57-1.46,15.42-3.59,15.16-11.17,15.16-11.17l7.58,3.72-3.32,18.43,6.78.98v5.19l-5.86,7.31,5.86,4.79-1.77,7.71s4.38,5.05,4.14,9.57-35.88,20.46-35.88,20.46l-11.43,18.1-19.95-22.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.78,174.66s4.31,3.77,3.32,6.85-14.88,14.22-14.88,14.22c0,0,8.87,1.4,12.57,0s4.74-1.32,4.74-1.32l1.83-16.03-7.58-3.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.38,196.36s-.85,6.06-3.03,7.76-5.28,3.3-5.28,3.3l4.49.87,5.62-4.57-1.37-5.92-.43-1.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.44,211.95s-1.01,5.26-3.08,8.09c0,0,2.44,10.2,1.69,11.99s-33.15,16.08-35.14,18.9-6.81,13.9-6.81,13.9h3.49l6.73-12.01s12.58-5.71,24.77-11.52,11.22-7,10.91-11.07-3.94-7.44-3.94-7.44c0,0,4.99-7.37,4.14-8.75s-2.74-2.09-2.74-2.09h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.21,204.1c-5.02,1.03-4.83,1.11-16.83,12.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.52,224.65c6.2-4.21,9.13-7.09,11.32-7.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M36.71,356.63c.02-8.52,2.85-21.81,2.85-21.81l13.07-14.97h9.51s5.47-5.23,6.65-12.6-.19-10.46,5.08-10.93,22.11-23.89,22.11-23.89l-3.47-4.99,11.55-13.38,3.66,1.83,10.56-10.62s21.41,8.11,23.79,11.18,9.02,24.36,9.02,30.84-1.83,18.73-1.83,18.73c0,0-34.96,22.64-36.19,27.74s-20.17,30.41-22.11,32.53c-1.54,1.68-40.82,15.29-42.2,14.08l-12.06-23.75h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "91.2 267.97 92.48 272.43 95.37 267.4 91.2 267.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M149.3,274s-10.04,22.48-18.77,26.41c-8.73,3.93-23.85,16.81-37.25,16.81,0,0,14.76-.65,13.67,4.58s-22.27,36.46-36.46,44.31-25.34,9.47-29.15,4.95l7.43,9.31,40.36-13.1s20.91-27.44,23.95-33.51c3.04-6.07,36.19-27.74,36.19-27.74,0,0,2.39-14.1,1.83-18.73s-1.8-13.3-1.8-13.3h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hand_Lines",
    "data-name": "Hand Lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M122.71,245.27c2.83-4.37,5.69-8.94,6.25-10.34,1.16-2.91-1.66-27.48.28-30.19s11.68-16.31,14.74-16.74c5.46-.77,11.25-1.73,13.8-2.96,9.17-4.42,13.1-12.27,16.75-11.95,1.37.12,8.12,2.59,9.28,5.09s-2.61,17.47-2.61,17.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M179.94,184.92c-.38,5.15-9.46,12.24-8.06,12.03,1.45-.22,11.86-2.46,14.36-.56s1.88,6.01,1.88,7.54-5.83,4.77-5.83,4.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M181.1,208.29c2.35,1.01,7.78,3.68,7.08,7.8-.89,5.23-4.06,5.07-2.04,7.19,2.41,2.52,3.14,4.87,3.14,9.18,0,2.87-3.78,4.97-3.78,4.97,0,0-20.63,12.07-31.57,17.05,0,0-3.07,4.13-6.99,10.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M59.84,317.71s-2.35,0-6.87.18-14.29,13.57-15.19,18.09-1.13,11.13-1.13,19.36,8.98,26.19,12.35,26.19,34.05-7.86,42.29-13.47,17.96-29.7,28.61-38.45,30.99-22.71,30.99-22.71c0,0,1.42-12.77,1.42-18.69s-6.39-26.02-7.81-30.99-25.31-12.77-28.39-12.3l-8.64,8.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M51.16,359.85s-3.26-22.79-2.17-26.77,16.46-15.74,17-22.79,1.63-13.93,5.06-15.19,28.4,6.51,46.3,2.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M92.76,273.76s-4.52-6.15-1.09-7.23,21.16,9.95,23.33,10.31,6.69,10.13,9.04,10.49,13.2,4.7,13.2,4.7v-13.02c0-1.27-5.06-11.39-6.51-12.3s-23.29-12.98-27.63-13.88l-12.23,14.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M95.99,268.39s-10.17,18.7-22.11,26.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121.96,272.85c5.12-4.46,12.96,3.81,8.05,7.73-5.95,4.75-11.44-4.77-8.05-7.73Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalconreport);
export default __webpack_public_path__ + "static/media/falcon report.665aa6585246846353f0fe6ba7c32afb.svg";
export { ForwardRef as ReactComponent };